/*
A Generic class to create an HTML View in browser's window.document
Required: identifier, 0-many templates 
*/
import addStyleTextInIframe from './hooks/addStyleTextInIframe';
import parseTemplate from './hooks/parseTemplate';
import WidgetTypes from './enums/WidgetTypes';
import AgentImageHandler from './hooks/AgentImageHandler';
import getStyleForIframe from './hooks/getStyleForIframe';
import observe from './hooks/observe';
import showElement from './hooks/showElement';
import hideElement from './hooks/hideElement';

export default class WidgetView {
    constructor(options) {
        // if (!options.identifier) {
        //     throw 'identifier is mandatory';
        // }
        this.options = options;
        this.DOM = options.dom;
        this.identifier = options.identifier; // EP, DOM or Windowed, etc
        this.elements = options.elements ? options.elements : {}; // key-val
        this.templates = options.templates; // key-val
        if (this.options.style) {
            // w idget level css
            this.style(this.options.style);
        }
        if (this.options.cssLink) {
            getStyleForIframe(this.options.cssLink, this.options.linkId, undefined, this.DOM);
        }
        // widget level beforeRender
        if (this.options.beforeRender) {
            window.setTimeout(this.options.beforeRender.bind2(this), 0);
        }
        if (options.initialState) {
            this.render(options.initialState);
        }
        // apply polyfills if any - widget level
        if (this.options.polyfills) {
            this.pollyfill(this, this.options.polyfills);
        }
    }

    getBody() {
        return this.DOM.getElementsByTagName('body')[0];
    }

    /*
    selectors: is a string containing one or more CSS selectors separated by commas.
    */
    bind(selector, ev, cb) {
        // not tested/used much yet
        let elMatched;
        try {
            elMatched = this.DOM.querySelector(selector);
        } catch (e) {
            throw 'invalid selector';
        }
        if (elMatched) {
            observe(elMatched, ev, cb.bind2(this, cb)); // invoke cb with in 'this' context
        }
    }

    reRender(model) {
        const wrapper = this.DOM.querySelector(this.elements.containerSelector);
        wrapper.innerHTML = parseTemplate(model.chatWidgetTemplate, model);
    }

    getContainer() {
        return this.elements.containerSelector;
    }

    render(state) {
        const me = this;
        // grab target based on state and show it if already present
        const wrapperContainer = this.DOM.getElementById(this.identifier + state);
        if (wrapperContainer) {
            showElement(wrapperContainer);
            return;
        }
        const tpl = this.templates.find((tpl) => tpl.key == state);
        let wrapper;
        if (tpl) {
            // tpl level beforeRender
            if (tpl.beforeRender) {
                tpl.beforeRender(tpl);
            }
            const target = tpl.model.targetElementId
                ? this.DOM.getElementById(tpl.model.targetElementId)
                : this.getBody();
            wrapper = tpl.containerElemType
                ? this.DOM.createElement(tpl.containerElemType)
                : this.DOM.createElement('div');

            tpl.model.handlerImageUrl = AgentImageHandler(tpl.model.handlerImageUrl);
            wrapper.innerHTML = tpl.tpl;
            if (tpl.style) {
                // tpl level css
                this.style(tpl.style);
            }
            if (tpl.cssLink) {
                getStyleForIframe(tpl.cssLink, tpl.linkId, undefined, this.DOM);
            }
            const containerId = tpl.containerId ? tpl.containerId : this.identifier + state;
            wrapper.setAttribute('id', containerId);
            if (this.identifier != WidgetTypes.ExitPopup) {
                // In case of ExitPopup we dont need this.
                hideElement(wrapper);
            }
            this.elements.containerSelector = `#${containerId}`;
            target.appendChild(wrapper);

            // apply polyfills if any - particular template/view level
            if (tpl.polyfills) {
                this.pollyfill(tpl, tpl.polyfills);
            }
        } else {
            throw `no state found with the key: ${state}`;
        }
        // tpl level afterRender
        if (tpl.afterRender) {
            if (
                this.identifier === WidgetTypes.ExitPopup ||
                this.identifier === WidgetTypes.PreChat
            ) {
                // In case of ExitPopup and prechat we dont need this.
            } else {
                window.setTimeout(() => {
                    if (this.identifier === WidgetTypes.DOM) {
                        wrapper.style.visibility = 'hidden';
                    }
                    showElement(wrapper);
                }, 0);
            }
            window.setTimeout(tpl.afterRender.bind2(this, tpl), 0);
        }
        // widget level afterRender
        if (this.options.afterRender) {
            this.options.afterRender.bind2(this);
        }
    }

    unrender(state, remove) {
        // grab target based on state and hide it if already present
        const wrapperContainer = this.DOM.getElementById(this.identifier + state);
        if (wrapperContainer) {
            hideElement(wrapperContainer);
        }
        // remove altogether if asked
        if (remove == true) {
            try {
                this.DOM.body.removeChild(wrapperContainer);
            } catch (e) { }
        }
    }

    style(css) {
        const cssArr = Array.isArray(css) ? css : [css]; // css could be a single obj or list of css obj's
        for (let i = 0; i < cssArr.length; i++) {
            addStyleTextInIframe(cssArr[i], undefined, undefined, this.DOM);
        }
    }

    // These are callback functions which get invoked after rendering a view
    pollyfill(scope, callbacks) {
        const tweaksArr = Array.isArray(callbacks) ? callbacks : [callbacks]; // tweaks could be a single func or list of func
        for (let i = 0; i < tweaksArr.length; i++) {
            const tweak = tweaksArr[i];
            if (typeof tweak === 'function') {
                try {
                    tweak.apply(scope, tweak.arguments);
                } catch (e) {
                    // console.log(e);
                }
            }
        }
    }
}
